// English labels for plan and purchase-order timelines (Stage 3). Request
// events reuse the Lane C labels (eventLabel in strings.ts).
import { eventLabel } from './strings'
import type { TimelineEntry } from './visibilityTypes'

export const TL = {
  title: 'What happened',
  by: 'by',
  pin: 'PIN',
  empty: 'Nothing recorded yet.',
  failed: 'Could not load the history.',
}

const LABELS: Record<string, string> = {
  plan_created: 'Plan written',
  plan_confirmed: 'Plan confirmed — sheet worked out',
  plan_sent: 'Sent to the store',
  plan_started: 'Cooking started',
  plan_done: 'Plan finished',
  plan_cancelled: 'Plan cancelled',
  batch_planned: 'Batch planned',
  batch_started: 'Batch started',
  batch_done: 'Batch made',
  batch_cancelled: 'Batch cancelled',
  po_created: 'Order written',
  po_approved: 'Order approved',
  received: 'Received',
  received_voided: 'Receipt voided',
  returned_to_supplier: 'Sent back to the supplier',
  returned_to_supplier_voided: 'Return voided',
  'inventory.po_create': 'Order written',
  'inventory.po_submit': 'Sent for approval',
  'inventory.po_approve': 'Order approved',
  'inventory.po_receive': 'Delivery received',
  'inventory.po_close': 'Order closed',
  'inventory.po_cancel': 'Order cancelled',
  'inventory.po_whatsapp': 'Sent to the supplier on WhatsApp',
  'inventory.po_photo_add': 'Delivery slip photo added',
  'inventory.po_photo_remove': 'Delivery slip photo removed',
  'inventory.quick_purchase': 'Bought and received',
  'inventory.plan_wrap_up': 'Wrapped up',
}

// Batch 5: what was thrown away or written off against a plan, by reason.
const WASTE: Record<string, string> = {
  damaged: 'Written off — broken or damaged',
  leftover: 'Thrown away — left over',
  spoiled: 'Thrown away — spoiled',
  burnt: 'Thrown away — burnt',
  expired: 'Thrown away — expired',
  returned: 'Thrown away — returned',
  batch_failed: 'Used up — a batch made nothing',
}

/** A person-readable label; request events (source 'requisition') use Lane C's. */
export function timelineLabel(e: Pick<TimelineEntry, 'source' | 'event_type'>): string {
  if (e.source === 'requisition') return eventLabel(e.event_type)
  if (e.source === 'waste') return WASTE[e.event_type.replace(/^waste_/, '')] ?? 'Written off'
  return LABELS[e.event_type] ?? e.event_type.replace(/^inventory\./, '').replace(/_/g, ' ')
}

/** "10 kg Rice" / "Rice" / "". */
export function timelineWhat(e: Pick<TimelineEntry, 'item_name' | 'qty' | 'unit'>): string {
  if (!e.item_name) return ''
  if (e.qty == null) return e.item_name
  return `${Math.round(e.qty * 1000) / 1000}${e.unit ? ` ${e.unit}` : ''} ${e.item_name}`
}
